import {Card} from "@material-tailwind/react";
import {useTranslation} from "react-i18next";
import {Skeleton} from "../../../components/general/Skeleton";
import {validEmptyText} from "../../../utils/textOptions";

export type typeEconomicValue = 'assets' | 'income' | 'expenses' | 'equity';

interface Props {
    className?: string,
    type: typeEconomicValue,
    value?: number,
    loading?: boolean,
}
const EconomicValue = ({className, type, value, loading}: Props) => {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const getIlutration = (type: typeEconomicValue) => {
      switch (type) {
          case 'assets':
          case 'equity':
              return '/assets/images/activos.png';
          case 'income':
              return '/assets/images/ingresos.png';
          case 'expenses':
              return '/assets/images/gasto.png';
      }
    }

    const getValue = (value: number | undefined) => {
      if (value === undefined) {
          return ''
      }
      return (value / 1000) > 0 ? (value / 1000).toFixed(1) : 0
    }

    return(
        <Card placeholder='card-eco-value'
              className={`${validEmptyText(className)} min-w-[215px] max-h-[90px] !border-[1px] border-secondary rounded-[5px] flex flex-row items-center gap-2 p-3`}>
            <div className={'bg-icon rounded-[20px] p-3'}>
                <img width={45} src={getIlutration(type)} alt={'img'}/>
            </div>
            <div className={'ml-auto flex flex-col'}>
                <span className={'ml-auto text-header text-[15px] uppercase font-extralight'}>{`${t(type)}`}</span>
                {loading ? <Skeleton/> :<span className={'text-header text-[35px] font-semibold'}>{`$${getValue(value)}K`}</span>}
            </div>
        </Card>
    )
}

export default EconomicValue
